import React from "react";
import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { QA_DOCUMENTATION_PERMS_ACTIONS } from "../../enum";
import {
    LLM_DOCUMENT_DELETE_PERMISSION,
    LLM_DOCUMENT_UPDATE_PERMISSION,
} from "components/dashboard/TrainSAM/SAM/LLMDocumentation/permissions";

const QaDocumentationTableDropdown = ({ qaDocumentation, handleActionModal }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleActionModal(value, qaDocumentation)}
            options={[
                {
                    value: QA_DOCUMENTATION_PERMS_ACTIONS.EDIT_QA_DOCUMENTATION,
                    label: "Edit LLM Document",
                    baseResources: LLM_DOCUMENT_UPDATE_PERMISSION,
                },
                {
                    value: QA_DOCUMENTATION_PERMS_ACTIONS.DELETE_QA_DOCUMENTATION,
                    label: "Delete LLM Document",
                    baseResources: LLM_DOCUMENT_DELETE_PERMISSION,
                },
            ]}
        />
    );
};

export default QaDocumentationTableDropdown;
